import { ApiConnectionListSearchCriteria } from '../models';

export class ApiConnectionListLoad {
  public static readonly type = '[ApiConnectionList] Load';
  constructor(public payload: ApiConnectionListSearchCriteria) {}
}

export class ApiConnectionListInitialState {
  public static readonly type = '[ApiConnectionList] Set initial state';
}
